/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

require("core-js/modules/esnext.map.delete-all");
require("core-js/modules/esnext.map.every");
require("core-js/modules/esnext.map.filter");
require("core-js/modules/esnext.map.find");
require("core-js/modules/esnext.map.find-key");
require("core-js/modules/esnext.map.from");
require("core-js/modules/esnext.map.group-by");
require("core-js/modules/esnext.map.includes");
require("core-js/modules/esnext.map.key-by");
require("core-js/modules/esnext.map.key-of");
require("core-js/modules/esnext.map.map-keys");
require("core-js/modules/esnext.map.map-values");
require("core-js/modules/esnext.map.merge");
require("core-js/modules/esnext.map.of");
require("core-js/modules/esnext.map.reduce");
require("core-js/modules/esnext.map.some");
require("core-js/modules/esnext.map.update");
require("core-js/modules/esnext.set.add-all");
require("core-js/modules/esnext.set.delete-all");
require("core-js/modules/esnext.set.difference");
require("core-js/modules/esnext.set.every");
require("core-js/modules/esnext.set.filter");
require("core-js/modules/esnext.set.find");
require("core-js/modules/esnext.set.from");
require("core-js/modules/esnext.set.intersection");
require("core-js/modules/esnext.set.is-disjoint-from");
require("core-js/modules/esnext.set.is-subset-of");
require("core-js/modules/esnext.set.is-superset-of");
require("core-js/modules/esnext.set.join");
require("core-js/modules/esnext.set.map");
require("core-js/modules/esnext.set.of");
require("core-js/modules/esnext.set.reduce");
require("core-js/modules/esnext.set.some");
require("core-js/modules/esnext.set.symmetric-difference");
require("core-js/modules/esnext.set.union");
require("core-js/modules/web.dom-collections.iterator");
require('./ie11');

// React 16+ relies on Map, Set, and requestAnimationFrame

require('raf').polyfill();